import { subscribe as subscribeURL } from 'constants/api-urls';
import { dispatchError } from 'reducers/helpers';
import { SET_SUBSCRIPTION_EMAIL, SET_IS_FETCHING_SUBSCRIPTION } from 'reducers/actions-types';
import axios from 'axios';

/**
 * Subscribe an email address in order to receive notification from the application
 * @param { string } email
 * @param { string } zip
 * @returns {function: Promise}
 */
export function subscribe({ email, zip }) {
    return function(dispatch) {
        dispatch({ type: SET_IS_FETCHING_SUBSCRIPTION, isFetching: true });

        return axios
            .post(subscribeURL(), { email, zip: parseInt(zip) })
            .then(() => {
                dispatch({ type: SET_IS_FETCHING_SUBSCRIPTION, isFetching: false });
                dispatch({ type: SET_SUBSCRIPTION_EMAIL, email });
            })
            .catch(e => {
                dispatchError(dispatch, e, {
                    url: subscribeURL(),
                    description: e.message,
                });

                dispatch({ type: SET_SUBSCRIPTION_EMAIL, email: '', error: e.message });
                dispatch({ type: SET_IS_FETCHING_SUBSCRIPTION, isFetching: false });
            });
    };
}

/**
 * TODO: remove after prelaunch
 * Subscribe an email address in order to receive notification from the application
 * @param { string } email
 * @param { string } zip
 * @returns {function: Promise}
 */
export function subscribePrelaunch({ email, zip }) {
    return function(dispatch) {
        dispatch({ type: SET_IS_FETCHING_SUBSCRIPTION, isFetching: true });

        return axios
            .post(subscribeURL(), { email: email, zip: parseInt(zip) })
            .then(() => {
                dispatch({ type: SET_IS_FETCHING_SUBSCRIPTION, isFetching: false });
            })
            .catch(e => {
                dispatchError(dispatch, e, {
                    url: subscribeURL(),
                    description: e.message,
                });

                dispatch({ type: SET_IS_FETCHING_SUBSCRIPTION, isFetching: false });
            });
    };
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/subscription/helpers.js